import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Button,
  Modal,
  Table,
  Alert,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory, Link } from "react-router-dom";
export default function FoodAppliedBanner() {
  const sort = 5;
  const activePag = useRef(0);
  const history = useHistory();
  const [data, setData] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [banners, setBanners] = useState("");
  const [show, setShow] = useState(false);
  const [acceptStatus, setAcceptStatus] = useState(false);
  const [bannerId, setBannerId] = useState("");
  const [searchData, setSearchData] = useState([]);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };
 
  const handleClose = () => {
    setShow(false);
  };
  function getData() {
    axios
      .get(`${Baseurl.baseurl4}/go-food-admin/get-approval-food-banner`)
      .then((res) => {
        console.log("result", res.data);
        setSpinner(false);
        setBanners(res.data.banner);
        setSearchData(res.data.banner)
        setData(document.querySelectorAll("#job_data tbody tr"));
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }

  useEffect(() => {
    getData();
  }, []);
  

  function rejectBanner(e) {
    e.preventDefault();
    axios
      .put(Baseurl.baseurl4 + `/go-food-admin/reject-food-banner/${bannerId}`)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Rejected", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function acceptBanner(e) {
    e.preventDefault();
    axios
      .put(Baseurl.baseurl4 + `/go-food-admin/approve-food-banner/${bannerId}`)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Accepted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      if (val.RestaurantName.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setBanners(filteredData);
  }
  

  return (
    <div>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Body>
          {acceptStatus ? (
            <h4>Are you sure !! you want to Accept Banner</h4>
          ) : (
            <h4>Are you sure !! you want to Reject Banner</h4>
          )}
        </Modal.Body>
        <Modal.Footer>
          {acceptStatus ? (
            <Button
              variant="primary"
              onClick={(e) => {
                acceptBanner(e);
              }}
            >
              Accept
            </Button>
          ) : (
            <Button
              variant="primary"
              onClick={(e) => {
                rejectBanner(e);
              }}
            >
              Reject
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
              searchRider(e.target.value);
              }}
            />
          </div>
         
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>

                    <th>
                      <strong>Image</strong>
                    </th>

                    <th>
                      <strong>Restaurant</strong>
                    </th>
                    <th>
                      <strong>offer</strong>
                    </th>
                    <th>
                      <strong>No Of Days</strong>
                    </th>
                    <th>
                      <strong>Amount</strong>
                    </th>

                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {banners &&
                    banners.map((val, key) => (
                      <tr key={val._id}>
                        <td>{key + 1}</td>
                        <td>
                          <img
                            src={val.FoodBanner}
                            height={40}
                            width={40}
                            alt="profile"
                          />
                        </td>
                        <td>{val.RestaurantName}</td>
                        <td>{val.RestaurantOffer}</td>
                        <td>{val.NoOfDay}</td>
                        <td>{val.Amount}</td>

                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  setAcceptStatus(true);
                                  setShow(true);
                                  setBannerId(val._id);
                                }}
                              >
                                Accept
                              </Dropdown.Item>

                              <Dropdown.Item
                                onClick={() => {
                                  setAcceptStatus(false);
                                  setShow(true);
                                  setBannerId(val._id);
                                }}
                              >
                                Reject
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!banners && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero Banners
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
